import {View} from 'P24C';
import mainTpl from '../templates/main';

export default class extends View {
    template = mainTpl;

    static displayName = 'StaticInfo';
}
